<template>
  <div>
    <div class="mt-6 mb-12 pt-5 bg-white rounded-lg shadow-ts1 mx-2 md:mx-0 lg:mx-0">
      <div class="w-full pb-4 border-b border-gray-400 border-solid">
        <h2 class="ltr:pl-5 ltr:md:pl-8 rtl:pr-5 rtl:md:pr-8 text-blue font-display font-bold text-xl leading-none">{{
          $t('finished').tTitle() }}</h2>
      </div>

      <div class="w-auto mt-8 pb-5 mx-5 lg:mx-0">
        <div v-if="!errorGettingCompetitions"
          class="inline-grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-5 w-full lg:px-6 pb-3.5 md:pb-0 ">
            <CompetitionCard v-for="competition in competitions" :key="competition.id" type="finished" :competition="competition" @openRules="openRulesModal = true"/>
          </div>
        <div v-else>
          <h4 class="ltr:pl-5 ltr:md:pl-8 rtl:pr-5 rtl:md:pr-8">{{ $t('error_getting_competitions') }}</h4>
        </div>
      </div>
    </div>
    <Modal :opened="openRulesModal" :title="$t('rules')" @close="openRulesModal = false">
      <Rules />
    </Modal>
    <!-- <Modal :opened="openCantEnterCompetition" :title="$t('oh_snap')" @close="openCantEnterCompetition = false">
      <div class="w-11/12 lg:w-[442px] max-w-[442px]">
        <p class="text-gray-900 text-base">{{ enterCompetitionErrorDialog }}</p>
        <button
          class="py-3 h-full bg-blue rounded-md text-white appearance-none font-medium mt-5 text-base text-center w-40 ltr:float-left rtl:float-right cursor-pointer">
          <router-link :to="'/' + Language + '/'">{{ $t('go_to_dashboard') }}</router-link></button>
      </div>
    </Modal> -->
  </div>
</template>

<script>
import CompetitionCard from './CompetitionCard.vue'
import Modal from '@/components/reusableComponents/Modal.vue';
import Rules from './shared-components/Rules.vue';
import { service } from '@/main'
import { mapGetters, mapActions } from 'vuex';

export default {

  data() {
    return {
      competitions: [],
      errorGettingCompetitions: false,
      openRulesModal: false,
    }
  },
  components: { CompetitionCard, Modal, Rules },
  mounted() {
    this.getCompetitions()
  },
  watch: {},
  computed: {
    ...mapGetters({
      Language: "language/code",
      User: 'user/all',
    })
  },
  methods: {
    getCompetitions() {
      this['logoLoader/set'](true)
      this.errorGettingCompetitions = false
      service.get('/trading-competition/all').then(res => {
        if (res.data) {
          this.competitions = res.data.finished_competitions;
          this['logoLoader/set'](false)
        } else {
          this.errorGettingCompetitions = true
          this['logoLoader/set'](false)
        }
      }).catch(err => {
        console.log(err)
        this.errorGettingCompetitions = true
        this['logoLoader/set'](false)
      })
    },
    ...mapActions(['logoLoader/set']),
  }

}
</script>
